import React, { Suspense } from "react";
import DefaultLayout from "./common/DefaultLayout";

import EditBadgeModal from "./modals/EditBadgeModal"

import {
  useGetExhibitorByTokenQuery,
  useDeleteBadgeMutation,
  BadgeModel,
} from '../api'
import ConfirmModal from './modals/ConfirmModal';

import { useAppContext } from '../contexts/app'
import EditExhibitorModal from "./admin/modals/EditExhibitorModal";
import MailNotificationModal from "./modals/MailNotificationModal";
import { makeBadgeMailMessage, calcMaxBadgesCount } from "../utils";

const HomePage = () => {
  const [showModal, setShowModal] = React.useState<string|undefined>(undefined);
  const [badgeLoadingsMap, setBadgeLoadings] = React.useState<{[key: string]: boolean}>({});
  const [deleteBadgeMutation] = useDeleteBadgeMutation();

  const { authToken, downloadBadge } = useAppContext()
  const { data, refetch } = useGetExhibitorByTokenQuery({
    fetchPolicy: 'network-only',
    variables: {
      token: authToken!
    }
  });

  if (!data) {
    return <DefaultLayout>
      <Suspense fallback={<div>...Loading</div>}>
        <div className='text-center'>
          <i className="fa fa-sync-alt fa-spin"></i>
        </div>
      </Suspense>
    </DefaultLayout>
  }

  const exhibitor = data.getExhibitorByToken;
  const badges = exhibitor.badges;
  const download = async (badge: BadgeModel) => {
    if (badgeLoadingsMap[badge.id]) return;
    setBadgeLoadings(previousState => ({...previousState, [badge.id]: true}))
    try {
      await downloadBadge(badge)
    } catch (e) {
      setBadgeLoadings(previousState => ({...previousState, [badge.id]: false}))
      return
    }
    setBadgeLoadings(previousState => ({...previousState, [badge.id]: false}))
  }

  const onEdited = async () => {
    setShowModal(undefined)
    await refetch()
  }

  const deleteBadge = async (id: string) => {
    await deleteBadgeMutation({
      variables: { id, exhibitorId: exhibitor.id },
    })
    setShowModal(undefined)
    await refetch()
  }
  
  return (
    <DefaultLayout isWide exhibition={exhibitor.exhibition}>
      <div>
        新たに出展社バッジを発行する場合は、「新規バッジ登録」ボタンをクリックして登録してください。<br/>
        出展社バッジを発行する場合は、「バッジ」ボタンを押してPDFを表示させ印刷してご利用ください。<br/>
        情報変更する場合は、「編集」ボタンを押して編集してください。
      </div>
      <div className="btn-group">
        <div className="btn mr-2" onClick={() => setShowModal('create-badge')}>新規バッジ登録</div>
        {/* {badges.length < calcMaxBadgesCount(exhibitor.boothsCount!) &&
          <div className="btn mr-2" onClick={() => setShowModal('create-badge')}>新規バッジ登録</div>
        } */}
        <EditBadgeModal
          type="create"
          exhibitor={exhibitor}
          isOpen={showModal === 'create-badge'}
          handleCloseModal={() => setShowModal(undefined)}
          handleSubmit={() => onEdited()}
        />
        <div className="btn mr-2" onClick={() => setShowModal('read-exhibitor')}>出展者情報確認</div>
        <EditExhibitorModal
          type="readonly"
          exhibitor={exhibitor}
          isOpen={showModal === 'read-exhibitor'}
          handleCloseModal={() => setShowModal(undefined)}
          handleSubmit={() => onEdited()}
        />
      </div>
      <div className="text-right">
        バッジ登録数 {badges.length} 枚
        {/* バッジ登録数 {badges.length} 枚 / 最大 {calcMaxBadgesCount(exhibitor.boothsCount!)} 枚 */}
      </div>
      <table>
        <tbody>
          {badges.map((badge, i) => {
            return <tr key={i}>
              <td>{badge.companyName}</td>

              <td>{badge.department}</td>

              <td>{badge.position}</td>

              <td>{badge.displayName}</td>

              <td>
                <div>
                  <span className="mail-is-notified">
                    {badge.badgeNotifiedAt ? <i className="checked"/> : "未"}
                  </span>
                  <div className="mail-link" onClick={() => setShowModal(badge.id+"-badge")}>バッジ通知</div>
                  <MailNotificationModal 
                    title={badge.companyName!}
                    type="badge"
                    exhibitorId={exhibitor.id}
                    badgeId={badge.id}
                    notifiedAt={badge.badgeNotifiedAt}
                    target={badge.companyName!}
                    message={makeBadgeMailMessage(badge, exhibitor.id)}
                    to={badge.email!}
                    isOpen={showModal === badge.id+"-badge"}
                    handleCloseModal={() => setShowModal(undefined)}
                    handleSubmit={() => onEdited()}
                  />
                </div>
              </td>

              <td className="tight-3">
                <div className={"btn" + (badgeLoadingsMap[badge.id] ? " loading" : "")} onClick={() => download(badge)}>
                  {!badgeLoadingsMap[badge.id] &&
                    <span>バッジ</span>
                  }
                  {badgeLoadingsMap[badge.id] &&
                    <span>作成中<i className="fa fa-sync-alt fa-spin"></i></span>
                  }
                </div>
              </td>

              <td className="tight-2">
                <div className="btn" onClick={() => setShowModal(badge.id+"-edit")}>編集</div>
                <EditBadgeModal
                  badge={badge}
                  exhibitor={exhibitor}
                  isOpen={showModal === badge.id+"-edit"}
                  handleCloseModal={() => setShowModal(undefined)}
                  handleSubmit={() => onEdited()}
                />
              </td>

              <td className="tight-2">
                <div className="btn" onClick={() => setShowModal(badge.id+"-delete")}>削除</div>
                <ConfirmModal 
                  title={`バッジを削除します。よろしいですか？`}
                  isOpen={showModal === badge.id+"-delete"}
                  handleCloseModal={() => setShowModal(undefined)}
                  handleSubmit={() => deleteBadge(badge.id)}
                />
              </td>
            </tr>
          })}
        </tbody>
      </table>
    </DefaultLayout>
  );
}

export default HomePage;
